// extracted by mini-css-extract-plugin
module.exports = {"aiIcon":"styles_aiIcon__HUCVo","aiIconInner":"styles_aiIconInner__VkY0d","iconText":"styles_iconText__ScWpt"};